export interface ChartGeometry {
  plotBottom: number;
  plotHeight: number;
  plotLeft: number;
  plotRight: number;
  plotTop: number;
  plotWidth: number;
  viewHeight: number;
  viewWidth: number;
  xLabelY: number;
}

export interface ChartGeometryOptions {
  axisGutter?: number;
  labelBand?: number;
  plotTop?: number;
  rightInset?: number;
}

const DEFAULT_AXIS_GUTTER = 104;
const DEFAULT_LABEL_BAND = 60;
const DEFAULT_PLOT_TOP = 18;
const DEFAULT_RIGHT_INSET = 36;
const X_LABEL_BOTTOM_INSET = 26;

const resolveDimension = (value: number): number => (Number.isFinite(value) ? Math.max(0, value) : 0);

export const resolveChartGeometry = (
  viewWidth: number,
  viewHeight: number,
  options: ChartGeometryOptions = {},
): ChartGeometry => {
  const resolvedViewWidth = resolveDimension(viewWidth);
  const resolvedViewHeight = resolveDimension(viewHeight);
  const plotLeft = options.axisGutter ?? DEFAULT_AXIS_GUTTER;
  const plotRight = Math.max(0, resolvedViewWidth - (options.rightInset ?? DEFAULT_RIGHT_INSET));
  const plotTop = options.plotTop ?? DEFAULT_PLOT_TOP;
  const plotBottom = Math.max(0, resolvedViewHeight - (options.labelBand ?? DEFAULT_LABEL_BAND));

  return {
    plotBottom,
    plotHeight: Math.max(0, plotBottom - plotTop),
    plotLeft,
    plotRight,
    plotTop,
    plotWidth: Math.max(0, plotRight - plotLeft),
    viewHeight: resolvedViewHeight,
    viewWidth: resolvedViewWidth,
    xLabelY: Math.max(0, resolvedViewHeight - X_LABEL_BOTTOM_INSET),
  };
};
